import React from 'react'

const AboutMKS = () => {
  return (
    <div style={{ color: 'white' }}></div>
  )
}

export default AboutMKS